import React from 'react';
import usePlacesAutocomplete, {getDetails} from 'use-places-autocomplete';

import styles from './LocationPage.module.scss';

// Google Places Autocomplete input restricted to Ukrainian street addresses.
// On select it resolves place details and hands the full result back to the
// parent (which parses + reverse-fills the structured fields and the map).
const PlacesAutocomplete = ({initialValue = '', onResolve}) => {
    const {
        ready,
        value,
        suggestions: {status, data},
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete({
        requestOptions: {
            componentRestrictions: {country: 'ua'},
            types: ['address'],
        },
        debounce: 300,
        defaultValue: initialValue,
    });

    const handleSelect = async (suggestion) => {
        const description = suggestion.description;
        setValue(description, false);
        clearSuggestions();

        try {
            const details = await getDetails({
                placeId: suggestion.place_id,
                fields: ['address_components', 'formatted_address', 'geometry', 'place_id'],
            });

            const location = details?.geometry?.location;
            const lat = location ? location.lat() : null;
            const lng = location ? location.lng() : null;

            onResolve({
                result: details,
                placeId: details?.place_id || suggestion.place_id,
                lat,
                lng,
            });
        } catch (error) {
            console.error('Places getDetails error:', error);
        }
    };

    return (
        <label id={'address'} className={styles.label}>
            <span>Адреса <span className={styles.req}>*</span></span>
            <div className={styles.autocomplete}>
                <input
                    className={styles.input}
                    value={value}
                    disabled={!ready}
                    onChange={(e) => setValue(e.target.value)}
                    placeholder={'Почніть вводити адресу...'}
                    autoComplete={'off'}
                />
                {status === 'OK' && (
                    <ul className={styles.suggestions}>
                        {data.map((suggestion) => (
                            <li
                                key={suggestion.place_id}
                                onClick={() => handleSelect(suggestion)}
                            >
                                {suggestion.description}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </label>
    );
};

export default PlacesAutocomplete;
